<script>
import { Link, useNavigate } from "svelte-navigator";
import { forgotPassword } from './services';

const navigate = useNavigate();



let loading = false;
let email = '';
let error;

let sent = false;

async function handleSubmit(e) {
  e.preventDefault();

  if (email.trim().length === 0) {
    return;
  }

  error = undefined;
  loading = true;

  try {
    await forgotPassword(email);
    sent = true;
  } catch (e) {
    error = e.message;
  } finally {
    loading = false;
  }
}
</script>


<div class="box">
  <div class="content">
    <div class="login-title">
      {!sent ? 'Forgot your password?' : 'A Link Has Been Sent!'}
    </div>

    <div class="login-subtitle">
      {!sent ? 'That’s not a problem! Enter your e-mail address below and we’ll send you a link to reset your password.' :
      'Check your email for a link to reset your password. This may take a few minutes.'}
    </div>

    {#if !sent}

      <form on:submit={handleSubmit}>
        {#if error}
          <div class="error-box mb-16">{error}</div>
        {/if}

        <div class="col mb-16">
          <div class="form-label">Email</div>
          <input bind:value={email} type="email" name="email" placeholder="Email" />
        </div>

        <div class="row vcenter between" style="margin-top: 48px">
          <Link to="/signin">Back to login</Link>
          <button type="submit" class="button" disabled={loading}>SUBMIT</button>
        </div>
      </form>

    {:else}

      <div class="button" on:click={() => navigate('/signin', {replace: true})}>BACK TO LOGIN</div>

    {/if}
  </div>
</div>

<style lang="scss">
@import './login';
</style>